/* i18n setup for PowerBuilt.
 *
 * Why: SXM operates in EN / NL / FR / ES daily. Locking to English
 * limits trust on the island and against off-island competitors.
 *
 * Pattern: load all 4 dictionaries upfront (combined < 30KB), let
 * react-i18next swap them via context. Language preference persists
 * in localStorage under `pb_lang`.
 */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "@/i18n/locales/en.json";
import nl from "@/i18n/locales/nl.json";
import fr from "@/i18n/locales/fr.json";
import es from "@/i18n/locales/es.json";

export const LANGS = [
  { code: "en", label: "English",  flag: "🇬🇧" },
  { code: "nl", label: "Nederlands", flag: "🇳🇱" },
  { code: "fr", label: "Français",   flag: "🇫🇷" },
  { code: "es", label: "Español",    flag: "🇪🇸" },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      nl: { translation: nl },
      fr: { translation: fr },
      es: { translation: es },
    },
    fallbackLng: "en",
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "pb_lang",
      caches: ["localStorage"],
    },
    react: { useSuspense: false },
  });

export default i18n;
